import React, {memo} from 'react';
import Typography from "../../../../components/Typography";
import InfoIcon from '@mui/icons-material/Info';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {password} from "../../../../utils/validations";

const PasswordPolicy = ({passwordFromForm = null}) => {
    const renderIcon = (validateFn) => {
        const isValid = passwordFromForm ? validateFn?.(passwordFromForm) : "error"
        if (typeof isValid === "boolean")
            return (
                <div className="flex">
                    <CheckCircleIcon fontSize={"small"} className={"text-success-green"}/>
                </div>
            )
        else
            return (
                <div className={"flex"}>
                    <InfoIcon fontSize={"small"} className={"text-functional-red !h-5"}/>
                </div>
            )
    }
    const validations = password?.validate
    return (
        <div className={"mt-4 text-left"}>
            <Typography variant={"subtitle2"}>Minimum Password Requirements:</Typography>
            <div>
                <div className="flex items-center gap-2 mt-1">
                    <div>
                        {renderIcon(validations?.isLong)}
                    </div>
                    <div>
                        <Typography variant={"body1"}>Must be 8 character long</Typography>
                    </div>
                </div>
                <div className="flex items-center gap-2 mt-1">
                    <div>
                        {renderIcon(validations?.isLower)}
                    </div>
                    <div>
                        <Typography variant={"body1"}>Must contain at least 1 lowercase</Typography>
                    </div>
                </div>
                <div className="flex items-center gap-2 mt-1">
                    <div>
                        {renderIcon(validations?.isNumeric)}
                    </div>
                    <div>
                        <Typography variant={"body1"}>Must contain at least 1 number</Typography>
                    </div>
                </div>
                <div className="flex items-center gap-2 mt-1">
                    <div>
                        {renderIcon(validations?.isUpper)}
                    </div>
                    <div>
                        <Typography variant={"body1"}>Must contain at least 1 uppercase</Typography>
                    </div>
                </div>
                <div className="flex items-center gap-2 mt-1">
                    <div>
                        {renderIcon(validations?.isSpecialChar)}
                    </div>
                    <div>
                        <Typography variant={"body1"}>Must contain at least 1 special character</Typography>
                    </div>
                </div>
                <div className="flex items-center gap-2 mt-1">
                    <div>
                        {renderIcon(validations?.isWhiteSpace)}
                    </div>
                    <div>
                        <Typography variant={"body1"}>Should not contain white space</Typography>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(PasswordPolicy);
